import { ITranslation } from "@/interfaces";
import { IDefaultRole } from "@/interfaces/IDefaultRole";
import { Collapse, CollapseProps, Table } from "antd";
import { useIntl } from "react-intl";

interface IProps {
  regions: { [id: string]: ITranslation };
  functionalAreas: { [id: string]: ITranslation };
  defaultRoles: IDefaultRole[];
}

export const ProjectRolesViewer = ({
  regions,
  functionalAreas,
  defaultRoles,
}: IProps) => {
  const intl = useIntl();

  const roleDefaultsColumns = [
    {
      title: intl.formatMessage({ id: "profile.projectRoleViewer.role" }),
      dataIndex: "name",
      key: "name",
    },
    {
      title: intl.formatMessage({ id: "profile.projectRoleViewer.region" }),
      dataIndex: "region",
      key: "region",
      render: (region: string) => regions[region]?.fallback,
    },
    {
      title: intl.formatMessage({
        id: "profile.projectRoleViewer.functionalArea",
      }),
      dataIndex: "functionalArea",
      key: "functionalArea",
      render: (functionalArea: string) =>
        functionalAreas[functionalArea]?.fallback,
    },
  ];

  const items: CollapseProps["items"] = [
    {
      key: "roleDefaults",
      label: intl.formatMessage({
        id: "profile.projectRoleViewer.roleDefaults",
      }),
      children: (
        <Table
          data-test-id="project-role-defaults-table"
          dataSource={defaultRoles}
          columns={roleDefaultsColumns}
          rowKey={({ name, region, functionalArea }) =>
            `${name}-${region}-${functionalArea}`
          }
          pagination={false}
        />
      ),
    },
  ];

  return (
    <Collapse
      data-test-id="project-role-collapse"
      defaultActiveKey={["roleDefaults"]}
      items={items}
    />
  );
};
